import { render, staticRenderFns } from "./mnGuestMessages.vue?vue&type=template&id=77693443"
import script from "./mnGuestMessages.vue?vue&type=script&lang=js"
export * from "./mnGuestMessages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports